module.exports = __webpack_public_path__ + "static/media/cover.0108d10c.jpg";